import { apiSlice } from '../../api';
import type {
  GetDocumentsDTO,
  GetDocumentsResult,
  UpdateDocumentTypeDTO,
  UpdateDocumentTypeResult,
  UploadDocumentDTO,
  UploadDocumentResult,
} from './types';

export const adminDocumentsEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => {
    return {
      getDocuments: build.query<GetDocumentsResult, GetDocumentsDTO>({
        query: ({ profileUid }) => ({
          url: `/admin/v1/profiles/${profileUid}/documents`,
          method: 'GET',
        }),
        providesTags: ['Documents'],
      }),

      uploadDocument: build.mutation<UploadDocumentResult, UploadDocumentDTO>({
        query: ({ profileUid, body }) => ({
          url: `/admin/v1/profiles/${profileUid}/documents`,
          method: 'POST',
          body,
        }),
        invalidatesTags: ['Documents'],
      }),

      updateDocumentType: build.mutation<UpdateDocumentTypeResult, UpdateDocumentTypeDTO>({
        query: ({ profileUid, documentId, body }) => ({
          url: `/admin/v1/profiles/${profileUid}/documents/${documentId}`,
          method: 'PUT',
          body,
        }),
        invalidatesTags: ['Documents'],
      }),
    };
  },
});

export const { useGetDocumentsQuery } = adminDocumentsEndpoints;
export const { useUploadDocumentMutation } = adminDocumentsEndpoints;
export const { useUpdateDocumentTypeMutation } = adminDocumentsEndpoints;

export type AdminDocumentsController = typeof adminDocumentsEndpoints;
